import {
  AI,
  CSV,
  DOCX,
  EPS,
  JPG,
  PDF,
  PNG,
  PPT,
  PSD,
  XSL,
  XSL as XLSX,
} from '../assets/new-images/fileIcons';

// Mesmo mapa do QuestionFile.jsx (components/Data), extraído pra reuso na
// Documentação (redesign "Drive") sem duplicar de novo.
const fileIconMap = {
  AI,
  CSV,
  DOCX,
  EPS,
  JPG,
  PDF,
  PNG,
  PPT,
  PSD,
  XSL,
  XLSX,
};

export function getFileIcon(filename) {
  const extension = filename?.split('.').pop()?.toUpperCase() || '';
  return fileIconMap[extension];
}
